export const API_BASE_URL = (window as any).configs.REACT_APP_API;
export const AUTH_BASE_URL = (window as any).configs.REACT_APP_AUTH_BASE_URL;
export const AUTH_CLIENT_ID = (window as any).configs.REACT_APP_AUTH_CLIENT_ID;
